import * as Immutable from 'seamless-immutable';
import { Action } from 'redux';
import { isType } from 'typescript-fsa/lib';
import {
  addFailedZoneId,
  removeFailedZoneId,
  resetMediaForZoneId,
  updateMediaEntities,
} from './media.actions';
import { AppState } from '../../reducers';
import * as R from 'ramda';

export interface SupportedFilter {
  id: string;
  name: string;
  additional: boolean;
}

export interface MediaItem {
  id?: number;
  hash: string;
  meta?: {
    mime: string;
    image: {
      width: number;
      height: number;
    };
  };
  zoneId?: string;
}

interface Media {
  byId: {
    [key: string]: MediaItem;
  };
  failed: string[];
}

const initialState = Immutable.from<Media>({
  byId: {},
  failed: [],
});

export type MediaState = Media & Immutable.ImmutableObject<Media>;

export default function reduce(
  state: MediaState = initialState,
  action: Action
) {
  if (isType(action, updateMediaEntities)) {
    const {
      payload: { mediaItems },
    } = action;
    const { failed } = state;
    const zoneIds = R.reject(
      R.isNil,
      R.map((mediaItem: MediaItem) => mediaItem.zoneId, mediaItems)
    );

    return state.merge(
      {
        byId: mediaItems,
        failed: R.difference(failed, zoneIds as any),
      },
      { deep: true }
    );
  }

  if (isType(action, resetMediaForZoneId)) {
    const {
      payload: { zoneId },
    } = action;
    const { byId } = state;
    return state.merge({
      byId: R.filter(
        (mediaItem: MediaItem) => mediaItem.zoneId !== zoneId,
        byId
      ),
    });
  }

  if (isType(action, removeFailedZoneId)) {
    const {
      payload: { zoneId },
    } = action;
    const { failed } = state;
    const filtered = R.reject(
      (failedZoneId: string) => zoneId === failedZoneId,
      failed
    );
    return state.merge(
      {
        failed: filtered,
      },
      { deep: true }
    );
  }

  if (isType(action, addFailedZoneId)) {
    const { failed } = state;
    const {
      payload: { zoneId },
    } = action;
    const filtered = R.filter(
      (failedZoneId: string) => zoneId === failedZoneId,
      failed
    );
    return state.merge(
      {
        failed: R.append(zoneId, filtered),
      },
      { deep: true }
    );
  }

  return state;
}

export function getMediaItems(state: AppState) {
  const {
    entities: { media },
  } = state;
  return media.byId;
}

export function getFailedZoneIds(state: AppState) {
  const {
    entities: { media },
  } = state;
  return media.failed;
}

export function getMediaItemByZoneId(state: AppState, zoneId: string) {
  const mediaItems = getMediaItems(state);
  return R.find(mediaItem => mediaItem.zoneId === zoneId, R.values(mediaItems));
}

export function uploadFailedForZoneId(state: AppState, zoneId: string) {
  const failed = getFailedZoneIds(state);
  return R.find(
    (failedZoneId: string) => R.equals(failedZoneId, zoneId),
    failed
  );
}



// WEBPACK FOOTER //
// ./src/store/Entities/Media/media.reducer.ts